<template>
    <footer aria-labelledby="footer-heading">
        <h2 id="footer-heading"
            class="sr-only"
        >Footer</h2>

        <Container class="pb-8 pt-12">
            <div class="xl:hidden mb-12 xl:mb-0">
                <Advertisement type="mobile-banner" />
            </div>

            <div>
                <div class="flex flex-wrap justify-between gap-8">
                    <div class="shrink-0 space-y-4">
                        <Link :href="route('home')"
                              class="shrink-0 inline-flex justify-center items-center gap-x-2"
                        >
                            <img :src="Logo"
                                 class="block h-12 select-none"
                            />
                        </Link>

                        <p class="text-balance text-sm/6 text-gray-300">
                            The world of dogs and dog enthusiasts.
                        </p>

                        <div v-if="$page.props.dogdom.available_locales.length > 1"
                             class="flex items-center gap-x-4 xl:hidden max-w-fit"
                        >
                            <p class="text-balance text-sm/6 text-gray-400">
                                Change country:
                            </p>

                            <div class="relative">
                                <select v-model="locale"
                                        class="block w-full appearance-none rounded-md border border-transparent bg-gray-700 bg-none py-2 pl-3 pr-10 text-base text-white focus:border-white focus:outline-none focus:ring-1 focus:ring-white sm:text-sm"
                                >
                                    <option v-for="availableLocale in $page.props.dogdom.available_locales"
                                            :key="availableLocale.route_key"
                                            :value="availableLocale.route_key"
                                    >
                                        {{ availableLocale.country.en }}
                                    </option>
                                </select>

                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                                    <ChevronDownIcon aria-hidden="true"
                                                     class="size-4 text-white"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="grow hidden xl:block">
                        <Advertisement type="desktop-banner" />
                    </div>

                    <div v-if="$page.props.dogdom.available_locales.length > 1"
                         class="shrink-0"
                    >
                        <div class="hidden xl:flex xl:items-center xl:gap-x-4 xl:max-w-fit">
                            <p class="text-balance text-sm/6 text-gray-400">
                                Change country:
                            </p>

                            <div class="relative">
                                <select v-model="locale"
                                        class="block w-full appearance-none rounded-md border border-transparent bg-gray-700 bg-none py-2 pl-3 pr-10 text-base text-white focus:border-white focus:outline-none focus:ring-1 focus:ring-white sm:text-sm"
                                >
                                    <option v-for="availableLocale in $page.props.dogdom.available_locales"
                                            :key="availableLocale.route_key"
                                            :value="availableLocale.route_key"
                                    >
                                        {{ availableLocale.country.en }}
                                    </option>
                                </select>

                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                                    <ChevronDownIcon aria-hidden="true"
                                                     class="size-4 text-white"
                                    />
                                </div>
                            </div>
                        </div>

                        <a class="inline-block mt-8 xl:hidden xl:mt-0"
                           href="https://dognewsaustralia.com.au/"
                        >
                            <img :src="DogNewsAustralia"
                                 alt="Dogdom"
                                 class="w-36 rounded ring ring-white"
                            />
                        </a>
                    </div>
                </div>

                <div class="mt-16 grid grid-cols-2 gap-8 xl:grid-cols-6 xl:col-span-6 xl:mt-8">
                    <div class="md:grid md:grid-cols-3 md:gap-8 xl:contents">
                        <div>
                            <h3 class="text-sm/6 font-semibold text-white">Dogs</h3>
                            <ul class="mt-6 space-y-4"
                                role="list"
                            >
                                <li v-for="item in footerNavigation.pages"
                                    :key="item.name"
                                >
                                    <a v-if="!!item.external"
                                       :href="item.href"
                                       class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </a>

                                    <Link v-else
                                          :href="item.href"
                                          class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div class="mt-10 md:mt-0">
                            <h3 class="text-sm/6 font-semibold text-white">Events</h3>
                            <ul class="mt-6 space-y-4"
                                role="list"
                            >
                                <li v-for="item in footerNavigation.events"
                                    :key="item.name"
                                >
                                    <a v-if="!!item.external"
                                       :href="item.href"
                                       class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </a>

                                    <Link v-else
                                          :href="item.href"
                                          class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div class="mt-10 md:mt-0">
                            <h3 class="text-sm/6 font-semibold text-white">Resources</h3>
                            <ul class="mt-6 space-y-4"
                                role="list"
                            >
                                <li v-for="item in footerNavigation.resources"
                                    :key="item.name"
                                >
                                    <a v-if="!!item.external"
                                       :href="item.href"
                                       class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </a>

                                    <Link v-else
                                          :href="item.href"
                                          class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="md:grid md:grid-cols-2 md:gap-8 xl:contents">
                        <div>
                            <h3 class="text-sm/6 font-semibold text-white">
                                {{ $page.props.dogdom.footer.rankings.header }}
                            </h3>

                            <ul class="mt-6 space-y-4"
                                role="list"
                            >
                                <li v-for="item in footerNavigation.rankings"
                                    :key="item.name"
                                >
                                    <a v-if="!!item.external"
                                       :href="item.href"
                                       class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </a>

                                    <Link v-else
                                          :href="item.href"
                                          class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div class="mt-10 md:mt-0">
                            <h3 class="text-sm/6 font-semibold text-white">Dogdom</h3>
                            <ul class="mt-6 space-y-4"
                                role="list"
                            >
                                <li v-for="item in footerNavigation.dogdom"
                                    :key="item.name"
                                >
                                    <a v-if="!!item.external"
                                       :href="item.href"
                                       class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </a>

                                    <Link v-else
                                          :href="item.href"
                                          class="text-sm/6 text-gray-400 hover:text-white"
                                    >{{ item.name }}
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="hidden xl:contents">
                        <div class="space-y-6">
                            <h3 class="text-sm/6 font-semibold text-white">Dog News Australia</h3>

                            <a class="inline-block"
                               href="https://dognewsaustralia.com.au/"
                            >
                                <img :src="DogNewsAustralia"
                                     alt="Dogdom"
                                     class="w-48 rounded ring ring-white"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24 md:flex md:items-center md:justify-between">
                <div class="flex gap-x-6 md:order-2">
                    <a v-for="item in footerNavigation.social"
                       :key="item.name"
                       :href="item.href"
                       class="text-gray-400 hover:text-gray-300"
                       target="_blank"
                    >
                        <span class="sr-only">{{ item.name }}</span>

                        <component :is="item.icon"
                                   aria-hidden="true"
                                   class="size-6"
                        />
                    </a>
                </div>

                <p class="mt-8 text-sm/6 text-gray-400 md:order-1 md:mt-0">
                    &copy; 2025 Dogdom. All rights reserved.
                </p>
            </div>
        </Container>
    </footer>
</template>

<script setup>
import {Link}            from '@inertiajs/vue3';
import Container         from '@/js/Components/Container.vue';
import DogNewsAustralia  from '@/img/dog-news-australia.jpg';
import Logo              from '@/img/logo/logo-light-no-background-no-bleed.png';
import {ChevronDownIcon} from '@heroicons/vue/20/solid';
import Advertisement     from '@/js/Components/Advertisement.vue';
</script>

<script>
import {
    defineComponent,
    h,
} from 'vue';

export default {
    data() {
        return {
            locale: this.$page.props.dogdom.locale.route_key,
        };
    },

    watch: {
        locale: function (newValue) {
            this.$inertia.visit(route('home', {
                locale: newValue,
            }));
        },
    },

    computed: {
        footerNavigation: function () {
            return {
                pages: [
                    {name: 'Dog Breeds', href: route('breeds.index')},
                    {name: 'Dog Profiles', href: route('dogs.index')},
                    {name: 'Dog Breeder Profiles', href: route('breeders.index')},
                    {name: 'Litter Announcements', href: route('breed-notices.litter-announcements.index')},
                    {name: 'Puppies For Sale', href: route('breed-notices.litter-notices.index')},
                    {name: 'Mature Dogs For Sale', href: route('breed-notices.mature-dogs.index')},
                    {
                        name:     'Australian Dog World Hall Of Fame',
                        href:     'https://dognewsaustralia.com.au/hall-of-fame/',
                        external: true,
                    },
                ],

                events: [
                    {name: 'Results', href: route('results.index')},
                    {name: 'All Events', href: route('events.index')},
                    ...this.$page.props.dogdom.footer.events.urls,
                ],

                resources: [
                    {name: 'Dog Clubs', href: route('clubs.index')},
                    // {name: 'Membership Forms', href: route('organisations.index')},
                    {
                        name:     'Judge Profiles',
                        href:     'https://dogsaustralia.org.au/Judge/Result',
                        external: true,
                    },
                    {name: 'Judge Critiques', href: route('critiques.index')},
                ],

                rankings: this.$page.props.dogdom.footer.rankings.urls,

                dogdom: [
                    {name: 'About Us', href: route('about-us')},
                    {name: 'Pricing', href: route('pricing')},
                    {name: 'Privacy', href: route('privacy')},
                    {name: 'Terms', href: route('terms')},
                    {name: 'Help', href: route('help')},
                    {name: 'Contact Us', href: 'mailto:support@dogdom.com.au', external: true},
                    {
                        name:     'Feedback',
                        href:     route('feedback'),
                        external: true,
                    },
                ],

                social: [
                    {
                        name: 'Facebook',
                        href: 'https://www.facebook.com/dogdomofficial',
                        icon: defineComponent({
                                                  render: () =>
                                                              h('svg', {fill: 'currentColor', viewBox: '0 0 24 24'}, [
                                                                  h('path', {
                                                                      'fill-rule': 'evenodd',
                                                                      d:           'M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z',
                                                                      'clip-rule': 'evenodd',
                                                                  }),
                                                              ]),
                                              }),
                    },
                ],
            };
        },
    },
};
</script>